import { observable, action, decorate } from 'mobx';
import GlobalMetaTagsService from '../services/GlobalMetaTags.service';

class GlobalMetaTagsStore {
  metaTags = null;

  @action.bound
  async getMetaTagsData() {
    try {
      this.metaTags = await GlobalMetaTagsService.fetchMetaTagsData();
    } catch (e) {
      throw e;
    }
  }
}

decorate(GlobalMetaTagsStore, {
  metaTags: observable
});

export default new GlobalMetaTagsStore();



// WEBPACK FOOTER //
// ./src/stores/GlobalMetaTags.store.js